import { FC, memo, useCallback, useEffect, useState } from 'react'

import { FilterItemTransport, FilterTransport } from '../../../../../transports/filters-configuration-transport'
import RadioFilterItem from './radio-filter-item'

type Props = {
    filter: FilterTransport
    shouldCommit?: boolean
}

const RadioFilter: FC<Props> = ({ filter, shouldCommit = false }) => {
    const [selectedFilterItemPosition, setSelectedFilterItemPosition] = useState<number>(() => {
        return filter.items.findIndex(item => item.checked)
    })

    useEffect(() => {
        setSelectedFilterItemPosition(filter.items.findIndex(item => item.checked))
    }, [filter.items])

    const handleFilterItemClick = useCallback((filterItemPosition: number) => {
        setSelectedFilterItemPosition(filterItemPosition)
    }, [])

    return (
        <>
            {filter.items.map((filterItem: FilterItemTransport, index) => {
                return (
                    <RadioFilterItem
                        filterItem={filterItem}
                        filterType={filter.type}
                        key={filterItem.title}
                        filterItemPosition={index}
                        isFilterItemSelected={index === selectedFilterItemPosition}
                        onFilterItemClick={handleFilterItemClick}
                        shouldCommit={shouldCommit}
                    />
                )
            })}
        </>
    )
}

export default memo(RadioFilter)
